var React = require('react');

function ResourceMediumDeepDiveCourseInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M4 6V9.81348C5.54374 10.7089 9.70497 11.9624 14 9.81348V6","stroke":"#6B6B6B","strokeWidth":"1.2","key":0}),React.createElement("path",{"d":"M9.02158 1.04751L0.920823 4.02041C0.600838 4.13784 0.597002 4.58903 0.914943 4.71188L9.0156 7.84204C9.10265 7.87568 9.19921 7.87513 9.28586 7.8405L17.1192 4.7103C17.432 4.58533 17.4281 4.14129 17.1132 4.02179L9.27996 1.04893C9.19681 1.01737 9.10507 1.01687 9.02158 1.04751Z","stroke":"#6B6B6B","strokeWidth":"1.2","key":1}),React.createElement("path",{"d":"M2 5L2 10","stroke":"#6B6B6B","strokeLinecap":"round","key":2})]);
}

ResourceMediumDeepDiveCourseInline.defaultProps = {"width":"18","height":"12","viewBox":"0 0 18 12","fill":"none"};

module.exports = ResourceMediumDeepDiveCourseInline;

ResourceMediumDeepDiveCourseInline.default = ResourceMediumDeepDiveCourseInline;
